import dandarLogo from "../../assets/images/dandar-logo.png";

export function Logo({ className }: { className?: string }) {
  return (
    <div className={`flex items-center ${className}`}>
      <img src={dandarLogo} alt="Dandar Health" className="h-10" />
    </div>
  );
}
